import { AttributesMixin, Collection, define, Model, type } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { RemittanceAdviceVaultCard } from "./RemittanceAdviceVaultCart";

export interface RemittanceAdviceVaultCardFilters extends AttributesMixin<typeof RemittanceAdviceVaultCardFilters> { }
@define
export class RemittanceAdviceVaultCardFilters extends Model {
    static attributes = {
        state: type(Number).value(0)
    }
}

export interface RemittanceAdviceVaultPage extends AttributesMixin<typeof RemittanceAdviceVaultPage> { }
@define
export class RemittanceAdviceVaultPage extends Model {
    static endpoint = restfulIO('/api/v1/assetmaster/Assets');
    static idAttribute = "assetId";


    static attributes = {
        assetId: String,

        filter: type(RemittanceAdviceVaultCardFilters),
        sortBy: {
            name: 'createdOn',
            isAsc: false
        },

        remittanceNotes: type({items: [RemittanceAdviceVaultCard], count: Number }).endpoint(restfulIO('./')).dontSave,
        selected: Collection.ofRefs(RemittanceAdviceVaultCard)
    }
}